import { ShieldQuestion } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PolicyField } from "./PolicyField";
import type { PolicyCardProps } from "./policy-card.types";

// Spec 079 — a CONFIANÇA do OEE: a partir de quanta máquina sem dado o indicador deixa de ser
// afirmado com segurança. Nada aqui muda o OEE — muda o que a plataforma diz sobre ele.
export function OeeConfidenceCard({ register, errors, disabled }: PolicyCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <ShieldQuestion className="h-4 w-4 text-text-tertiary" aria-hidden />
          Confiança do OEE
        </CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4 sm:grid-cols-2">
        <PolicyField
          id="policy-nodata-high"
          label="Máquinas sem dado para confiança baixa"
          unit="%"
          hint="A partir desta fatia de máquinas sem leitura, a confiança do OEE do período é declarada Baixa. Precisa ser maior que a fatia da confiança média."
          registration={register("oeeConfidenceNodataHigh", { valueAsNumber: true })}
          error={errors.oeeConfidenceNodataHigh}
          disabled={disabled}
          step="0.01"
        />
        <PolicyField
          id="policy-nodata-low"
          label="Máquinas sem dado para confiança média"
          unit="%"
          hint="Acima desta fatia, e abaixo da anterior, a confiança é declarada Média."
          registration={register("oeeConfidenceNodataLow", { valueAsNumber: true })}
          error={errors.oeeConfidenceNodataLow}
          disabled={disabled}
          step="0.01"
        />
      </CardContent>
    </Card>
  );
}
